module.exports = __webpack_public_path__ + "static/media/tinyInfo.25416adb.svg";